import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { imageCategorySX } from '@/components/blocks/DpLibrary/DpMiniCardCategory/style/image';
import { titleCategorySX } from '@/components/blocks/DpLibrary/DpMiniCardCategory/style/typography';
import { Linkable } from '@/components/blocks/Linkable';
import React from 'react';

export const DpMiniCardCategory = ({
	title,
	image,
	href,
}: {
	title: string;
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	href?: string;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;
	return (
		<Grid>
			<Linkable href={href}>
				<Img src={getImage} sx={imageCategorySX} />
			</Linkable>
			<Typography component={'h2'} sx={titleCategorySX}>
				{' '}
				{title}{' '}
			</Typography>
		</Grid>
	);
};
